import type { NewsItem } from "@/types/media";

export const news: NewsItem[] = [
  {
    id: "n-001",
    title: "科幻巨制《流浪地球3》正式定档，概念预告首曝震撼世界引擎",
    category: "movie",
    date: "2026-10-12",
    summary:
      "备受期待的科幻续作正式宣布档期，最新概念预告展示了全面升级的世界引擎与行星推进器，视觉规模再攀新高。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20cinematic%20sci-fi%20space%20scene%20with%20glowing%20planetary%20engines%20under%20a%20deep%20blue%20starfield%2C%20warm%20orange%20accents%2C%20wide%20editorial%20photo%2C%20highly%20detailed%20concept%20art&width=1200&height=800&seq=news-liulang-31&orientation=landscape",
    content: [
      "经过多年筹备，科幻巨制《流浪地球3》今日正式宣布定档，同步曝光了一支时长九十秒的概念预告片。预告中，全面升级的世界引擎与行星推进器以震撼的姿态占据画面，配合低沉恢弘的配乐，瞬间点燃了观众的期待。",
      "据出品方介绍，本片在视觉特效上投入了前所未有的资源，多支国内顶尖特效团队协力合作，力求呈现更加真实可信的未来世界。制片人表示：“我们希望让每一位观众都能感受到人类在宇宙面前的渺小与伟大。”",
      "业内人士分析，随着国产科幻电影工业体系的逐步成熟，这一系列作品已经成为行业标杆。此次定档消息发布后，社交平台相关话题迅速登上热搜，讨论热度居高不下。",
      "影片主创团队尚未公布完整阵容，但已确认多位原班演员将回归。后续更多物料与幕后花絮将陆续释出，本刊将持续关注。",
    ],
    tags: ["科幻", "定档", "预告片"],
  },
  {
    id: "n-002",
    title: "年度剧王《狂飙》续作官宣，原班人马回归掀起期待",
    category: "tv",
    date: "2026-10-10",
    summary: "口碑与收视双丰收的扫黑剧集确认推出续作，主创团队延续前作风格，聚焦全新故事线。",
    cover:
      "https://readdy.ai/api/search-image?query=rainy%20southern%20chinese%20city%20street%20at%20night%20with%20warm%20streetlights%20and%20wet%20asphalt%2C%20sepia%20and%20amber%20tones%2C%20wide%20editorial%20photography%2C%20gritty%20crime%20drama%20atmosphere&width=1200&height=800&seq=news-kuangbiao-32&orientation=landscape",
    content: [
      "曾创下现象级收视的扫黑题材剧集《狂飙》今日官宣续作，原班主创团队将悉数回归。据悉，续作将延续前作扎实的现实主义底色，聚焦一条全新的故事线，探讨人性在时代洪流中的挣扎与选择。",
      "制片方在发布会上透露，剧本历经两年打磨，多次深入一线调研取材，力求在保持类型张力的同时，呈现更加立体的人物群像。导演表示：“我们不想简单重复过去的成功，而是希望在更深的人性层面做探索。”",
      "消息公布后，大量观众在评论区表达期待之情。有评论认为，前作的成功为国产现实主义剧集树立了新的标杆，续作能否延续辉煌备受关注。",
      "目前该剧已进入紧张的前期筹备阶段，预计明年正式开机。播出平台与具体档期尚未公布。",
    ],
    tags: ["剧集", "续作", "现实主义"],
  },
  {
    id: "n-003",
    title: "综艺市场迎来新格局，音乐竞演类节目集体升温",
    category: "variety",
    date: "2026-10-08",
    summary: "多档音乐竞演综艺相继上线，凭借创新的舞台呈现与真实的情感表达赢得观众好评。",
    cover:
      "https://readdy.ai/api/search-image?query=dazzling%20concert%20stage%20with%20warm%20golden%20spotlights%20and%20smoke%2C%20energetic%20amber%20accents%2C%20wide%20editorial%20photography%2C%20vibrant%20atmosphere&width=1200&height=800&seq=news-yinyue-33&orientation=landscape",
    content: [
      "进入本季度以来，综艺市场呈现出明显的回暖趋势，其中音乐竞演类节目表现尤为亮眼。多档新老节目相继上线，凭借精心设计的舞台与真实动人的表达，收获了不俗的口碑与热度。",
      "观察人士指出，与往年相比，今年的音乐综艺更加注重歌手的个人成长与情感故事，弱化了纯粹的竞技对抗，转而强调音乐本身的感染力。这种转变契合了当下观众对真诚内容的偏好。",
      "与此同时，舞台技术的升级也为节目增色不少。沉浸式的灯光与视觉设计，让每一场表演都像一场小型演唱会，极大提升了观看体验。",
      "有业内分析认为，随着观众审美水平的提升，综艺内容正从“流量驱动”走向“品质驱动”，谁能持续输出高质量内容，谁就能在竞争中占据主动。",
    ],
    tags: ["综艺", "音乐", "行业观察"],
  },
  {
    id: "n-004",
    title: "《长安三万里》重映引发国风热潮，动画电影迎来创作高峰",
    category: "movie",
    date: "2026-10-06",
    summary: "国风动画重映再度引爆观影热情，越来越多创作者投入传统文化题材的动画探索。",
    cover:
      "https://readdy.ai/api/search-image?query=sweeping%20ancient%20chinese%20landscape%20of%20misty%20mountains%20and%20rivers%20at%20golden%20hour%2C%20ink%20painting%20aesthetic%2C%20wide%20editorial%20photography%2C%20warm%20amber%20light&width=1200&height=800&seq=news-changan-34&orientation=landscape",
    content: [
      "国风动画电影《长安三万里》于本月初启动重映，再度点燃了观众的观影热情。不少影迷表示，在大银幕上重温那些熟悉的诗句与壮阔山河，依然令人动容。",
      "这部作品的成功，被业界视为国产动画在传统文化题材上的一次重要突破。它证明，植根本土文化的创作同样能够获得市场的广泛认可。",
      "受此带动，近两年已有多个传统文化题材的动画项目启动。从神话传说到历史人物，从诗词歌赋到民间故事，创作者们正以更加多元的视角挖掘本土题材的潜力。",
      "有评论指出，国风动画的崛起不仅是技术的进步，更是文化自信的体现。未来，如何在传承与创新之间找到平衡，将是这一类型持续发展的关键。",
    ],
    tags: ["动画", "国风", "重映"],
  },
  {
    id: "n-005",
    title: "《三体》衍生内容持续扩容，科幻影视工业化提速",
    category: "tv",
    date: "2026-10-04",
    summary: "随着科幻题材热度攀升，相关衍生内容不断丰富，国内科幻影视的工业化水平稳步提升。",
    cover:
      "https://readdy.ai/api/search-image?query=cosmic%20deep%20space%20scene%20with%20a%20lone%20tiny%20earth%20and%20vast%20swirling%20nebula%2C%20deep%20indigo%20and%20teal%20tones%2C%20wide%20editorial%20photography%2C%20awe%20inspiring&width=1200&height=800&seq=news-santi-35&orientation=landscape",
    content: [
      "自剧集《三体》播出以来，围绕这一科幻题材的衍生内容持续扩容。从纪录片到幕后特辑，从原声音乐到主题展览，内容丰富度不断提升，形成了颇具规模的IP生态。",
      "值得关注的是，这一系列作品在制作流程上的规范化探索，为国内科幻影视的工业化提供了宝贵经验。从概念设计到虚拟拍摄，再到后期特效，标准化的工作流程正在逐步建立。",
      "业内人士表示，科幻题材对制作水准的要求极高，它倒逼整个行业提升技术水平与管理能力。可以说，科幻影视的发展，是衡量一个地区影视工业成熟度的重要标尺。",
      "据悉，更多科幻题材项目已进入开发阶段。随着技术积累与人才培养的持续推进，国产科幻影视有望迎来更加蓬勃的发展期。",
    ],
    tags: ["科幻", "工业化", "IP"],
  },
  {
    id: "n-006",
    title: "老牌综艺焕新回归，情怀与创新如何平衡引热议",
    category: "variety",
    date: "2026-10-02",
    summary: "多档经典综艺相继推出全新一季，在保留情怀的同时尝试形式创新，引发观众广泛讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20sunny%20city%20street%20scene%20with%20colorful%20decorations%20and%20motion%20blur%2C%20warm%20amber%20and%20teal%20accents%2C%20wide%20editorial%20photography%2C%20playful%20upbeat&width=1200&height=800&seq=news-laoip-36&orientation=landscape",
    content: [
      "本季度，多档陪伴观众多年的经典综艺相继推出全新一季。它们在保留原有情怀元素的同时，纷纷在内容与形式上尝试创新，引发了观众的热烈讨论。",
      "有观众认为，熟悉的嘉宾阵容与标志性环节带来了强烈的情感联结，这是老牌综艺不可替代的优势。但也有声音指出，过度依赖情怀容易陷入套路，创新才是长久之道。",
      "节目制作方表示，团队一直在思考如何让经典IP保持活力。他们通过引入新的叙事结构、融入当下热点话题，努力在“熟悉感”与“新鲜感”之间寻找平衡。",
      "从市场反馈来看，这类节目依然拥有稳定的受众基础。如何在传承与创新之间找到最佳结合点，将是它们能否持续焕发生命力的关键。",
    ],
    tags: ["综艺", "情怀", "创新"],
  },
  {
    id: "n-007",
    title: "现实主义题材百花齐放，剧集创作回归生活本真",
    category: "tv",
    date: "2026-09-30",
    summary: "越来越多剧集将镜头对准普通人的日常生活，以细腻笔触描绘时代变迁下的酸甜苦辣。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20northern%20chinese%20old%20residential%20neighborhood%20at%20golden%20hour%20with%20brick%20buildings%2C%20faded%20warm%20amber%20and%20olive%20tones%2C%20wide%20editorial%20photography&width=1200&height=800&seq=news-xianshi-37&orientation=landscape",
    content: [
      "近年来，现实主义题材剧集呈现出百花齐放的态势。越来越多的创作者将镜头对准普通人的日常生活，用细腻的笔触描绘时代变迁下个体的酸甜苦辣。",
      "与过往相比，当下的现实主义创作更加注重细节的真实与情感的真挚。无论是家庭伦理、职场奋斗，还是乡村变迁、城市生活，都能在观众中引发广泛共鸣。",
      "评论界认为，这种创作倾向的回归，反映了观众对真诚内容的渴望。当故事扎根于真实的生活土壤，它便拥有了穿越时间的力量。",
      "有编剧坦言，写好现实题材并不容易，它要求创作者真正沉下心来观察生活、理解时代。唯有如此，才能写出打动人心的作品。",
    ],
    tags: ["剧集", "现实主义", "创作趋势"],
  },
  {
    id: "n-008",
    title: "暑期档票房再创新高，国产影片表现格外抢眼",
    category: "movie",
    date: "2026-09-28",
    summary: "今年暑期档总票房刷新历史同期纪录，多部国产影片凭借扎实内容赢得观众与市场认可。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinema%20lobby%20with%20glowing%20marquee%20lights%20at%20evening%2C%20amber%20and%20crimson%20accents%2C%20wide%20editorial%20photography%2C%20festive%20atmosphere&width=1200&height=800&seq=news-piaofang-38&orientation=landscape",
    content: [
      "据最新统计，今年暑期档总票房刷新了历史同期纪录，观影人次同样创下新高。在整体市场回暖的背景下，多部国产影片表现格外抢眼。",
      "从题材来看，涵盖科幻、动画、悬疑、喜剧等多种类型的国产影片均有不俗表现，呈现出类型多元、百花齐放的态势。这也说明，只要内容过硬，观众愿意走进影院。",
      "业内人士分析，档期的成功离不开内容质量的整体提升。越来越多创作者意识到，单纯依靠营销与流量已难以打动成熟起来的观众，好故事才是根本。",
      "展望未来，随着更多优质项目储备逐步释放，电影市场有望延续良好势头。行业回暖的信心正在持续增强。",
    ],
    tags: ["票房", "暑期档", "市场"],
  },
  {
    id: "n-009",
    title: "纪录片迎来黄金时代，真实影像力量打动万千观众",
    category: "variety",
    date: "2026-09-25",
    summary: "自然、人文、历史等各类纪录片持续走红，真实影像以其独特魅力赢得越来越广泛的受众。",
    cover:
      "https://readdy.ai/api/search-image?query=majestic%20natural%20landscape%20of%20misty%20mountains%20and%20a%20lone%20ranger%20at%20dawn%2C%20soft%20teal%20and%20amber%20tones%2C%20wide%20editorial%20photography%2C%20serene%20atmosphere&width=1200&height=800&seq=news-jilupian-39&orientation=landscape",
    content: [
      "近年来，纪录片正迎来属于自己的黄金时代。无论是探索自然奥秘、记录人文风貌，还是回溯历史长河，各类纪录片都在持续走红，收获了大量忠实观众。",
      "与虚构叙事不同，纪录片以其真实的力量打动人。镜头下的一草一木、一颦一笑，都承载着生活的质感与时代的印记，让观众在观看中获得独特的共鸣与思考。",
      "制作水准的不断提升，也是纪录片走红的重要原因。精良的摄影、动人的配乐与扎实的叙事，让这一类内容摆脱了“严肃枯燥”的刻板印象。",
      "有平台负责人表示，观众的审美正在变得更加多元与成熟，真实影像的价值正被越来越多的人看见。未来，纪录片有望走进更广阔的大众视野。",
    ],
    tags: ["纪录片", "真实影像", "内容趋势"],
  },
];